export default __webpack_public_path__ + "assets/audios/5cfb58d7625911460b39f6371b2037df.mp3";